import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import tpl from './my-benefit-template.hbs';
import { state } from '../state-manager/state-model';
import { eventBus } from '../state-manager/event-bus';

export var HowPcbangView = Backbone.View.extend({
  el: '.app__how-pcbang',

  template: tpl,

  initialize: function () {
    this.eventBus = eventBus;
    this.state = state;

    if (!this.state.get('guest')) {
      this.model.fetch(); // 로그인 했을 때만
    }

    this.renderCouponId();

    this.listenTo(this.model, 'sync', this.render);
    this.listenTo(this.model, 'change:couponId', this.onChangeCoupon);

    this.$money = this.$('[data-how-click=money]');
    this.$pchip = this.$('[data-how-click=pchip]');
    this.$kickout = this.$('[data-how-click=kickout]');
    this.$input = this.$('[data-how-coupon-input]');

    this.$myBenefit = this.$('[data-how-my-benefit]');
  },

  events: {
    'click [data-how-click]': 'handleClick',
    'change [data-how-coupon-input]': 'onInputChanged',
    'input [data-how-coupon-input]': 'onInputPressed'
  },

  handleClick: function (e) {
    e.preventDefault();

    if (this.state.get('guest')) {
      location.assign(this.state.get('loginUrl'));
      return;
    }

    if (this.state.get('maintenance')) {
      this.eventBus.trigger('show:maintenance');
      return;
    }

    if (this.state.get('nru')) {
      this.eventBus.trigger('show:newUser');
      return;
    }

    var $el = $(e.currentTarget);
    var which = $el.data('how-click');

    if (/^(kickout|pchip|money)$/.test(which)) {
      this.model.setType(which);
      this.model.save();
    } else if (/^(openAttendance|runGame)$/.test(which) && _.isFunction(this[which])) {
      this[which].call(this, e);
    } else if (which === 'myBenefit') {
      this.$myBenefit.toggle(); // show | hide : 내가 받은 혜택 레이어
    } else {
      throw new Error('No method found!');
    }
  },

  render: function () {
    var data = this.model.toJSON();
    var now = new Date();
    var resultMessage;

    var myBenefit = this.template({
      today: now.getFullYear() + '년 ' + (now.getMonth() + 1) + '월 ' + now.getDate() + '일',
      nickname: this.state.get('nickname'),
      isNoData: !data.isKicoutItemReceived && !data.isMoneyReceived && !data.isPchipReceived,
      isPchipReceived: data.isPchipReceived,
      isMoneyReceived: data.isMoneyReceived,
      isKicoutItemReceived: data.isKicoutItemReceived
    });

    this.$('[data-how-my-benefit]').html(myBenefit);

    if (data.isKicoutItemReceived) {
      this.$kickout.addClass('done').html('혜택 받기 완료');
    } else if (data.isKicoutItemReceived === false) {
      this.$kickout.removeClass('done');
    }

    if (data.isMoneyReceived) {
      this.$money.addClass('done').html('혜택 받기 완료');
    } else if (data.isMoneyReceived === false) {
      this.$money.removeClass('done');
    }

    if (data.isPchipReceived) {
      this.$pchip.addClass('done').html('혜택 받기 완료');
    } else if (data.isPchipReceived === false) {
      this.$pchip.removeClass('done');
    }

    resultMessage = this.model.get('resultText');

    if (resultMessage) {
      this.eventBus.trigger('show:message', {
        title: '알림',
        message: resultMessage.split('\n')
      });
    }

    this.eventBus.trigger('app:refresh');

    return this;
  },

  renderCouponId: function () {
    var coupon = this.model.get('couponId');
    var words = coupon.match(/(\w\w\w\w)/g);
    this.$('[data-how-coupon-input]').each(function (i, el) {
      $(el).val(words[i]);
    });

    return this;
  },

  onInputChanged: function () {
    var val = '';
    this.$input.each(function (i, el) {
      val += $(el).val();
    });
    this.model.set('couponId', val.toUpperCase());
  },

  /** 쿠폰 코드 입력할 때마다 대문자로 변경 */
  onInputPressed: function () {
    this.$input.each(function (i, el) {
      var $el = $(el);
      $el.val($el.val().toUpperCase());
    });
  },

  onChangeCoupon: function () {
    this.model.setRealCoupon();
  },

  openAttendance: function (e) {
    e.preventDefault();

    if (this.state.get('howPcbang')) {
      this.eventBus.trigger('open:attendance');
    } else {
      this.eventBus.trigger('show:message', {
        title: '알림',
        message: ['죄송합니다.', '하우’ PC방에서만', '혜택을 받으실 수 있습니다.']
      });
    }
  },

  runGame: function (e) {
    e.preventDefault();

    if (this.state.get('howPcbang')) {
      this.eventBus.trigger('app:runGame');
    } else {
      this.eventBus.trigger('show:message', {
        title: '알림',
        message: ['죄송합니다.', '하우’ PC방에서만', '혜택을 받으실 수 있습니다.']
      });
    }
  }
});
